import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useMutation, useQueryClient } from 'react-query';
import Form from '../../../../../commons/Form/Form';
import { useCurrentUser } from '../../../../../../hooks/useCurrentUser/useCurrentUser';
import { User, UserRoles } from '../../../../../../types/models/user/user.types';
import { useState } from 'react';
import { ProfilePasswordFormSchema } from './ProfilePasswordForm.types';
import { getProfilePasswordSchema } from './ProfilePasswordForm.schema';
import { profilePasswordData } from './ProfilePasswordForm.data';
import ProfilePasswordModal from '../ProfilePasswordModal/ProfilePasswordModal';
import {
  UPDATE_USER_PASSWORD_QUERY_KEY,
  updateUserPasswordQuery,
} from './ProfilePasswordForm.query';
import { BaseResponse } from '../../../../../../types/api/api.types';

export default () => {
  const queryClient = useQueryClient();

  const currentUser = useCurrentUser() as User;

  const [isModalOpen, setModalOpen] = useState(false);

  const formProps = useForm<ProfilePasswordFormSchema>({
    resolver: yupResolver(getProfilePasswordSchema),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const { handleSubmit } = formProps;

  const { mutate } = useMutation<Awaited<BaseResponse>, Error, ProfilePasswordFormSchema>(
    (data) => updateUserPasswordQuery(data),
    {
      mutationKey: UPDATE_USER_PASSWORD_QUERY_KEY,
      onMutate: () => queryClient.cancelMutations(),
      onSuccess: () => {
        setModalOpen(true);
      },
      onError: (error) => {
        alert(error.message);
      },
    }
  );

  const onSubmit = handleSubmit((data) => mutate(data));

  return (
    <>
      <Form<ProfilePasswordFormSchema>
        data={profilePasswordData}
        {...{ formProps, onSubmit }}
        isCompany={currentUser.role === UserRoles.Entreprise}
        buttonLabel="Mettre à jour"
      />
      <ProfilePasswordModal isOpen={isModalOpen} setOpen={setModalOpen} closeOnClickOutside />
    </>
  );
};
